var render, staticRenderFns
import script from "./CompanyPreferencesForm.vue?vue&type=script&lang=js&"
export * from "./CompanyPreferencesForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('054c7aea')) {
      api.createRecord('054c7aea', component.options)
    } else {
      api.reload('054c7aea', component.options)
    }
    
  }
}
component.options.__file = "module/Vrcci/Company/resources/vue/CompanyPreferencesForm.vue"
export default component.exports